import { Button, Card, Drawer, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useCaregiver } from "../../api/Caregivers";
import { UserNameDisplay } from "../UserDisplay";
import CaregiverSchedule from "./CaregiverSchedule";
import FavoriteCaregiverButton from "./FavoriteCaregiverButton";

const CaregiverCard = ({ userId, caregiver, favorites }) => {
  const [user, setUser] = useState(caregiver);
  const [showSchedule, setShowSchedule] = useState();

  const { isLoading, data } = useCaregiver(userId);

  useEffect(() => {
    if (data?.User) setUser(data.User);
  }, [data]);

  const cardActions = [];
  if (favorites)
    cardActions.push(
      <FavoriteCaregiverButton
        favorites={favorites}
        caregiver={user}
        size="small"
      />
    );
  cardActions.push(
    <Button onClick={() => setShowSchedule(true)} size="small">
      Schedule
    </Button>
  );

  return isLoading && !caregiver ? (
    <Skeleton avatar paragraph={3} active />
  ) : (
    <>
      <Card actions={cardActions}>
        <div style={{ textAlign: "center" }}>
          <UserNameDisplay user={user}></UserNameDisplay>
        </div>
      </Card>
      <Drawer
        open={showSchedule}
        onClose={() => setShowSchedule(false)}
        title={`Schedule with ${user?.FirstName}`}
      >
        <CaregiverSchedule caregiver={user} />
      </Drawer>
    </>
  );
};

export default CaregiverCard;
